import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react';
import Axios from 'axios';

const PackagingTypeDropdown = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {

    const [packagingType, setPackagingType] = useState([])
    const [isLoading, setIsLoading] = useState(false)


    useEffect(() => {
        setIsLoading(true)
        let token = localStorage.getItem('isloggedIn')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNumber')
 
        Axios.get(`${process.env.REACT_APP_MASTER_API}/packaging_type?userId=${userId}&customerNumber=${customerNo}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setPackagingType(response.data.resultSet)
            setIsLoading(false)
        }))
        .catch(error => {
            console.log(error);
            setIsLoading(false)
        })
            
    }, [])

    let options = []
    if (packagingType && packagingType.length > 0) {
        packagingType.map((object, index) => {
            let temp = {}
            temp.key = object.packagingTypeId
            temp.text = object.packagingType
            temp.value = object.packagingTypeId
            return options[index] = temp
        })
    }

    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }

    return (
        <Dropdown
            selection
            search
            loading={isLoading}
            clearable
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            error={props.error}
            {...props}
        />
    )
}
export default PackagingTypeDropdown